import { render, staticRenderFns } from "./task_beta.vue?vue&type=template&id=673a1dd4&scoped=true"
import script from "./task_beta.vue?vue&type=script&lang=ts"
export * from "./task_beta.vue?vue&type=script&lang=ts"
import style0 from "./task_beta.vue?vue&type=style&index=0&id=673a1dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a1dd4",
  null
  
)

export default component.exports